import { Box, Card, Divider } from '@mui/material';
import { FileWithPath } from 'react-dropzone';
import FileCard from 'src/components/atoms/file-card/file-card';

interface Props {
  files: FileWithPath[];
  onDeleteFile: (index: number) => void;
}

const FilesList = ({ files, onDeleteFile }: Props) => {
  return (
    <Card variant="outlined" sx={{ py: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
      {files.map((file, index) => (
        <>
          <Box sx={{ px: 6 }}>
            <FileCard
              key={index}
              size={file.size}
              path={file.path || ''}
              onDelete={() => onDeleteFile(index)}
            />
          </Box>
          {files.length > 1 && files.length - 1 !== index ? <Divider /> : null}
        </>
      ))}
    </Card>
  );
};

export default FilesList;
